import HtmlParser from 'html-react-parser';
import React from 'react';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import { DemoFormShort } from '../../components/DemoFormShort.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import MultimedialPanel from '../../components/MultimedialPanel';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="page-integrations org-chart" ontouchstart>
            <SEO title="Org Chart | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Create and update your organizational chart in seconds by connecting your People systems into one central hub. Finally, understand your org like never before."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Org Chart | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Create and update your organizational chart in seconds by connecting your People systems into one central hub. Finally, understand your org like never before." />
                <meta property="og:image" content={`https://www.charthop.com/home/meta-org-chart.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Org Chart | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Create and update your organizational chart in seconds by connecting your People systems into one central hub. Finally, understand your org like never before." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/meta-org-chart.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="intro container">
                <div className="row py-5 align-items-center">
                    <div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
                        <h1>It's more than just an Org Chart.</h1>
                        <p className="header-p pb-1 pt-1">It's everything you need to know about your team - all in one place.</p>
                        <div className="splitText"><DemoFormShort source={"product-org-chart-demo-header"} /></div>                        
                    </div>
                    <div className="reactPlayerContainer col-md-6 order-md-1 padding-top-video-one" >
						<ReactPlayer
							url="/videos/visualize-dei.mp4"
							playing
							loop
							muted
							playsinline
						/>
					</div>
                </div>
            </section>

            {/* customers */}
            <section className="customer testimonial-container backgroundGradientContainer pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
            </section>

            {/* Organizational Chart */}
            <section className="sectionSpacing flex-centeredColumn">
            <h2 className="text-center mt-0 sectionSpacing-Margin">The Organizational Chart of your dreams is here.</h2> 

            <div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
                    <div className="svg-info-card-3col">
							<img src={'/product/org-chart/visualize.svg'} alt="Visualize" />
							<h3>Visualize anything</h3>
							<p>See your Org Chart through any lens - from gender & ethnicity to span of control & performance. </p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/picture.svg'} alt="Put a face to the name" />
							<h3>Put a face to the name</h3>
							<p>Easily sync up employee pictures, add profiles and show the person beyond the box.  </p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/product/org-chart/time.svg'} alt="Time Saving" />
							<h3>Save hours of time </h3>
							<p> Watch as your Org Chart and data automatically update as your team changes.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/transparency.svg'} alt="Transparency" />
							<h3>Increase transparency</h3>
							<p>Give employees the context they need to be productive and feel engaged.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/work.svg'} alt="Work" />
							<h3>Show how work gets done</h3>
							<p> Go beyond reporting structures. Visualize matrixed organizations, teams and more. </p>
						</div>
                       
                        <div className="svg-info-card-3col">
							<img src={'/product/org-chart/data.svg'} alt="Data Access" />
							<h3>Control data access</h3>
							<p> Ensure data remains secure with robust and customizable data controls. </p>
						</div>
					</div>
				</div>

            </section>
            
            {/* Export */}
            <section className="sectionSpacing backgroundGradientContainer" id="export">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Export to slides"
                        link="/product/org-chart/export.mp4"
                        type="video"
                        paddingClass="padding-top-video-two"
                        content={
                            <React.Fragment>
                                <p>Share your Org Chart at your team, management and board meetings - no powerpoint skills required.</p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            {/* travel */}
            <section className="sectionSpacing" id="travel">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="left"
                        title="Travel through time"
                        link="/home/03_Time_Travel_04_Optimized.mp4"
                        type="video"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>Understand how your company has evolved over time and how it’s growing. See all your org’s history and future plans in one place.</p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            {/* plan */}
            <section className="sectionSpacing backgroundGradientContainer" id="plan">
				<div className="contentBlock">
                    <MultimedialPanel 
                        multimediaPosition="right"
                        title="Plan with context"
                        link="/home/05_Scenario_03_Optimized.mp4"
                        type="video"
                        paddingClass="padding-top-video-three"
                        content={
                            <React.Fragment>
                                <p>Forget manual spreadsheets. Build your future team visually and finally align People, Finance, Recruiting and hiring managers. </p>
                            </React.Fragment>
                        }
                    />
				</div>
			</section>

            <section className="sectionSpacing mx-0 mt-0">
                <h4 className="listTitle text-xs-left mt-0 text-sm-center">The best Org Chart, built for your every need.</h4>
                <div className="pgc1 pgc1-container">
                    <div className="pgc2">
                        <div className="pgc3">
                            <img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Onboard new employees</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img  className="align-bullets"  src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Create alternative team structures</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Clarify roles & responsibilities</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Boost productivity</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Increase belonging</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Visualize diversity across teams</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Understand the team's evolution</p>
                        </div>
                    </div>
                    <div className="pgc2">
                        <div className="pgc3">
                            <img className="align-bullets" src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
                            <p>Plan for future headcount growth</p>
                        </div>
                    </div>

                </div>
                <p className="subListTitle mb-0 font-weight-bold text-center">& more</p>
            </section>

            {/* AVAILABLE INTEGRATIONS */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
                <h2 className="text-center mt-0 sectionSpacing-Margin">Create and update your org chart automagically <span role="img" aria-label="sparkle">✨</span></h2> 
                <h4 className="text-center mt-0 sectionSpacing-Margin">Seamlessly integrate your HRIS or Payroll provider - no manual uploads required</h4>
                <div className="moreIntegrationsContent">
                    <div className="floating-minorCardContainer">

                        {/* FIRST 4 */}
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-bamboo@2x.jpg' alt="BambooHR" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-slack@2x.jpg' alt="Slack"/>
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-workday@2x.jpg' alt="Workday" />
                            </div>
                        </div>
                        <div>
                            <div>
                            <img src='/integrations/logos/logo-successfactors@2x.jpg' alt="Success Factors" />
                            </div>
                        </div>

                        {/* SECOND 4 */}  
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-greenhouse@2x.jpg' alt="Greenhouse" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-lever@2x.jpg' alt="Lever" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-carta@2x.jpg' alt="Carta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-e-trade@2x.jpg' alt="E-Trade" />
                            </div>
                        </div>

                        {/* THIRD 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-trinet@2x.jpg' alt="Trinet" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/gusto.png' alt="Gusto" /> 
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-rippling@2x.jpg' alt="Rippling" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-justworks@2x.jpg' alt="Justworks" />
                            </div>
                        </div>

                        {/* FOURTH 4 */}
                        <div>
                            <div>
                                <img src='/integrations/logos/sequoia.png' alt="Sequoia" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-paylocity@2x.jpg' alt="Paylocity" />
                            </div>
                        </div>
                        
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-namely@2x.jpg' alt="Namely" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/zenefits.png' alt="Zenefits" />
                            </div>
                        </div> 

                        {/* PSUEDO */}
                        <div className="psudeo ps1">
                        </div>

                        <div className="psudeo ps2">
                        </div>

                        <div className="psudeo ps3">
                        </div>

                        <div className="psudeo ps4">
                        </div>

                        {/* MORE */}
                        <h4 className="text-center">& more</h4>
                    </div>
                </div>
            </section>
            

            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"product-org-chart-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">“Being able to visualize the org chart by any dimension (department, time zone, gender, squad) has empowered my team to make more strategic people decisions. </p><p class="contact-testimonial">ChartHop has helped us create a more transparent organization and helped employees forge deeper relationships with their coworkers.”</p><div class="authorTag"><img src="/home/quotes/quote_ShelbyWolpa@2x.jpg" class="testimonialAuthor" alt="Shelby Wolpa" /><div><p class="contactAuthor"><strong>Shelby Wolpa</strong> <br>VP, People Operations, Invision</p></div></div>')}/>
			</section>
        </Layout>
    );
};


export default Home;
